import React from "react";
import { motion } from "framer-motion";
import Office_meeting from "../../assets/ImgAtAboutapge.png";
import { useTranslation } from "react-i18next";

export default function Main() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen">
      <section className="relative flex items-center justify-between h-[90vh] overflow-hidden">
        {/* Left Content */}
        <motion.div
          className="relative z-10 flex-1 flex items-center pl-10 md:pl-28"
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div>
            {/* Vertical label */}
            <div
              className="absolute
                -left-8      /* default: push more left on very small screens */
                sm:-left-10  /* 640px–767px: push even more left */
                md:-left-6   /* ≥768px: closer in, but still safe */
                lg:left-6    /* ≥1024px: as in original design */
                top-1/2 -translate-y-1/2 -rotate-90 
                text-green-900 font-semibold tracking-[0.3em] 
                text-[10px] sm:text-xs md:text-sm 
                whitespace-nowrap"
            >
              {t("about.label")}
            </div>
            <h2 className="font-arya text-[28px] md:text-[44px] font-semibold leading-tight text-gray-900 max-w-xl pl-16 md:pl-28 z-10  w-[500px]">
              {t("about.headline")}
            </h2>
          </div>
        </motion.div>

        {/* Right Image */}
        <motion.div
          className="absolute right-0 top-0 w-[65%] h-full z-0"
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <img
            src={Office_meeting}
            alt="Office meeting"
            className="w-full h-full object-cover"
          />
        </motion.div>
      </section>
    </div>
  );
}
